import { Controller } from "@hotwired/stimulus"

// Keeps the content-filtering control honest about the selected image provider.
//
// xAI Grok Imagine exposes NO moderation parameter of any kind, so when it is
// selected the filtering choice cannot do anything. Rather than leave a live
// control that silently no-ops, we disable it and swap in a plain explanation.
// The server enforces the same truth (Media::ImageProvider::Xai
// #supports_moderation? is false) — this is only so the screen doesn't lie
// before the next page load.
export default class extends Controller {
    static targets = ["filtering", "unsupportedNote", "supportedNote"]

    connect() {
        this.sync()
    }

    sync() {
        const selected = this.element.querySelector('input[name="assistant_persona[image_provider]"]:checked')
        const supported = selected ? selected.dataset.supportsModeration === "true" : true
        this.filteringTargets.forEach((el) => {
            el.querySelectorAll("input").forEach((input) => { input.disabled = !supported })
            el.classList.toggle("persona-setting-disabled", !supported)
        })
        this.unsupportedNoteTargets.forEach((el) => { el.hidden = supported })
        this.supportedNoteTargets.forEach((el) => { el.hidden = !supported })
    }
}
